import {ref} from "vue";
import {apiClient} from "@/services/auth-header";

/**
 * 현재 본인 인증 모드 (mimio#74).
 *
 * NICE  — 휴대폰 본인인증 + 이메일(해외 거주자). 원래 상태
 * EMAIL — 이메일 인증만. NICE 계약이 닫혀 있는 동안의 임시 상태
 *
 * 값은 백엔드 설정에서 온다. 그래서 갱신 후 원복할 때 프론트를 다시 배포할 필요가 없다 —
 * 서버 yml 한 줄을 NICE 로 되돌리고 재기동하면 이 화면들이 원래대로 돌아온다.
 *
 * 모듈 수준 ref 라 한 번만 받아 화면들이 공유한다.
 */
const mode = ref("NICE");
const notice = ref("");
let loaded = false;

export function useIdentityMode() {
  const load = async () => {
    if (loaded) {
      return;
    }
    try {
      const res = await apiClient.get("/v1/auth/identity/mode");
      mode.value = res.data?.mode === "EMAIL" ? "EMAIL" : "NICE";
      notice.value = res.data?.notice || "";
      loaded = true;
    } catch (e) {
      // 조회가 실패해도 화면은 떠야 한다. 기존 동작(휴대폰 + 이메일 둘 다 노출)으로 둔다.
      // loaded 를 세우지 않아 다음 진입에서 다시 시도한다.
      console.error("본인 인증 모드 조회 실패", e);
    }
  };

  return {mode, notice, load};
}
